export abstract class FileUrl {
  public abstract toString(): string
  public abstract getFilename(): string
  public abstract getExtension(): string
}
